import { Pet } from "./pet";

/**
 * PropType 的数据结构或可选取值约定。
 */
export enum PropType {
    /**
     * STAMINA，保存当前实例的STAMINA状态。
     */
    STAMINA = "stamina",
    /**
     * VITALITY，保存当前实例的VITALITY状态。
     */
    VITALITY = "vitality",
}

/** A consumable battle item owned independently by each Seer. */
export class Prop {
    /**
     * maxUses，保存当前实例的maxUses状态。
     */
    maxUses: number;
    /**
     * curUses，保存当前实例的curUses状态。
     */
    curUses: number;

    /**
     * 创建实例并初始化所需的领域状态。
     * @param name 名称
     * @param type type参数，参与本次操作
     * @param iconUrl iconUrl参数，参与本次操作
     * @param maxUses maxUses参数，参与本次操作；默认值为 `5`
     */
    constructor(
        public name: string,
        public type: PropType,
        public iconUrl: string,
        maxUses: number = 5
    ) {
        this.maxUses = this.curUses = maxUses;
    }

    /**
     * use：执行对应的领域操作。
     * @param pet 目标精灵
     * @returns 本次操作的结果；具体取值由当前状态与分支决定。
     */
    use(pet: Pet): boolean {
        if (this.curUses <= 0 || !pet.isAlive()) return false;

        this.curUses--;
        if (this.type === PropType.STAMINA) {
            pet.战斗面板.recoverHP = pet.recover(pet.最大体力);
        } else {
            pet.技能组.forEach((skill) => {
                skill.curPP = skill.maxPP;
            });
        }
        return true;
    }
}

/**
 * createDefaultProps：执行对应的领域操作。
 * @returns 本次操作的结果；具体取值由当前状态与分支决定。
 */
export function createDefaultProps(): Prop[] {
    return [
        new Prop(
            "体力药剂",
            PropType.STAMINA,
            "/assets/stamina-potion.svg"
        ),
        new Prop(
            "活力药剂",
            PropType.VITALITY,
            "/assets/vitality-potion.svg"
        ),
    ];
}
